"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Badge_1 = require("@mui/material/Badge");
var PickersDay_1 = require("@mui/x-date-pickers/PickersDay");
var DateCalendar_1 = require("@mui/x-date-pickers/DateCalendar");
var DayCalendarSkeleton_1 = require("@mui/x-date-pickers/DayCalendarSkeleton");
var Box_1 = require("@mui/material/Box");
require("./../custom.css"); // Tell webpack that Button.js uses these styles
var List_1 = require("@mui/material/List");
var Divider_1 = require("@mui/material/Divider");
var Fab_1 = require("@mui/material/Fab");
var Add_1 = require("@mui/icons-material/Add");
var TextField_1 = require("@mui/material/TextField");
var AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var TimePicker_1 = require("@mui/x-date-pickers/TimePicker");
var Stack_1 = require("@mui/material/Stack");
var Button_1 = require("@mui/material/Button");
var Event_1 = require("../models/Event");
var Event_2 = require("./Event");
var CloudUpload_1 = require("@mui/icons-material/CloudUpload");
var dayjs = require("dayjs");
var EventService_1 = require("../services/EventService");
var Role_1 = require("../shared/utilities/Role");
var material_1 = require("@mui/material");
var Toast_1 = require("../shared/utilities/Toast");
//import dayjs from 'dayjs' // ES 2015
dayjs().format();
//TODO: move to global
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
var calendarContainerStyleWhole = {
    width: '100%',
    float: 'left'
};
var calendarContainerStyleHalf = {
    width: '50%',
    float: 'left'
};
function getRandomNumber(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}
var initialValue = dayjs((new Date()).toDateString());
function ServerDay(props) {
    var _a = props.highlightedDays, highlightedDays = _a === void 0 ? [] : _a, day = props.day, outsideCurrentMonth = props.outsideCurrentMonth, other = __rest(props, ["highlightedDays", "day", "outsideCurrentMonth"]);
    var isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;
    return (React.createElement(Badge_1.default, { key: props.day.toString(), overlap: "circular", 
        //badgeContent={isSelected ? '⚫' : undefined}
        badgeContent: '' },
        React.createElement(PickersDay_1.PickersDay, __assign({ sx: {
                '&.Mui-selected': {
                    backgroundColor: '#231f20 !important',
                }
            }, className: isSelected ? 'hasEvent' : '' }, other, { outsideCurrentMonth: outsideCurrentMonth, day: day, disableRipple: true }))));
}
//TODO: move to common
var VisuallyHiddenInput = styles_1.styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
function Calendar() {
    var role = Role_1.default();
    var _a = React.useState(false), eventStartTimeInvalid = _a[0], setEventStartTimeInvalid = _a[1];
    var _b = React.useState(false), eventEndTimeInvalid = _b[0], setEventEndTimeInvalid = _b[1];
    var _c = React.useState(false), isInvalid = _c[0], setIsInvalid = _c[1];
    var _d = Toast_1.default(), showErrorMessage = _d.showErrorMessage, showSuccessMessage = _d.showSuccessMessage;
    var _e = React.useState(false), ready = _e[0], setReady = _e[1];
    var requestAbortController = React.useRef(null);
    var _f = React.useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = React.useState([]), highlightedDays = _g[0], setHighlightedDays = _g[1];
    var _h = React.useState([]), events = _h[0], setEvents = _h[1];
    var _j = React.useState([]), filteredEvents = _j[0], setFilteredEvents = _j[1];
    var _k = React.useState(initialValue), currentDate = _k[0], setCurrentDate = _k[1];
    var _l = React.useState(false), addingNewEvent = _l[0], setAddingNewEvent = _l[1];
    var _m = React.useState(''), eventName = _m[0], setEventName = _m[1];
    var _o = React.useState(''), eventDescription = _o[0], setEventDescription = _o[1];
    var _p = React.useState(''), eventLocation = _p[0], setEventLocation = _p[1];
    var _q = React.useState(initialValue), eventStartTime = _q[0], setEventStartTime = _q[1];
    var _r = React.useState(initialValue), eventEndTime = _r[0], setEventEndTime = _r[1];
    var _s = React.useState(''), eventId = _s[0], setEventId = _s[1];
    var _t = React.useState(''), eventCoordinators = _t[0], setEventCoordinators = _t[1];
    var _u = React.useState(undefined), file = _u[0], setFile = _u[1];
    var _v = React.useState(''), fileLocation = _v[0], setFileLocation = _v[1];
    var _w = React.useState(false), isMobile = _w[0], setIsMobile = _w[1];
    //choose the screen size 
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    };
    var getEvents = function (date) {
        setCurrentDate(date);
        EventService_1.default.GetEvents(date.year(), date.month() + 1).then(function (response) {
            if (response.Events != null) {
                setEvents(response.Events);
                handleDayChange(date, response.Events);
                updateHighlightedDays(response.Events, date);
            }
            else {
                showErrorMessage('Unknown error occurred getting events!');
            }
            setIsLoading(false);
            setReady(true);
        });
    };
    var updateHighlightedDays = function (events, date) {
        var daysToHighlight = [];
        for (var i = 0; i < events.length; i++) {
            if (events[i].EventStartTime.getMonth() == date.month()) {
                daysToHighlight.push(events[i].EventStartTime.getDate());
            }
        }
        setHighlightedDays(daysToHighlight);
    };
    var upsertEvent = function (event, documentBytes, documentName) {
        setReady(false);
        if (event.EventId == null || event.EventId == '') {
            EventService_1.default.CreateEvent(event.EventName, event.EventDescription, event.EventLocation, event.EventStartTime, event.EventEndTime, documentName, documentBytes, event.EventCoordinators).then(function (response) {
                if (response != null && response.Event != null) {
                    var newSetEvents = events;
                    if (response.Event.EventStartTime != null) {
                        response.Event.EventStartTime = new Date(response.Event.EventStartTime);
                    }
                    if (response.Event.EventEndTime != null) {
                        response.Event.EventEndTime = new Date(response.Event.EventEndTime);
                    }
                    newSetEvents.unshift(response.Event);
                    newSetEvents.sort(function (a, b) {
                        return a.EventStartTime.getTime() - b.EventStartTime.getTime();
                    });
                    setEvents(__spreadArray([], newSetEvents));
                    handleDayChange(currentDate, newSetEvents);
                    updateHighlightedDays(newSetEvents, currentDate);
                    showSuccessMessage('Event successfully added!');
                }
                else {
                    showErrorMessage('Unknown error occurred adding event!');
                }
                setReady(true);
            });
        }
        else {
            EventService_1.default.UpdateEvent(event.EventId, event.EventName, event.EventDescription, event.EventLocation, event.EventStartTime, event.EventEndTime, documentName, documentBytes, false, event.EventCoordinators).then(function (response) {
                if (response != null && response.Event != null) {
                    var newSetEvents = __spreadArray([], events);
                    if (response.Event.EventStartTime != null) {
                        response.Event.EventStartTime = new Date(response.Event.EventStartTime);
                    }
                    if (response.Event.EventEndTime != null) {
                        response.Event.EventEndTime = new Date(response.Event.EventEndTime);
                    }
                    var index = newSetEvents.map(function (event) { return event.EventId; }).indexOf(response.Event.EventId);
                    var item = __assign(__assign({}, events[index]), { EventName: response.Event.EventName, EventDescription: response.Event.EventDescription, EventStartTime: response.Event.EventStartTime, EventEndTime: response.Event.EventEndTime, EventLocation: response.Event.EventLocation, EventFileLocation: response.Event.EventFileLocation, EventCoordinators: response.Event.EventCoordinators });
                    newSetEvents[index] = item;
                    newSetEvents.sort(function (a, b) {
                        return a.EventStartTime.getTime() - b.EventStartTime.getTime();
                    });
                    setEvents(__spreadArray([], newSetEvents));
                    console.log('new events', newSetEvents);
                    handleDayChange(currentDate, newSetEvents);
                    updateHighlightedDays(newSetEvents, currentDate);
                    showSuccessMessage('Event successfully updated!');
                }
                else {
                    showErrorMessage('Unknown error occurred updating event!');
                }
                setReady(true);
            });
        }
    };
    React.useEffect(function () {
        window.addEventListener("resize", handleResize);
        handleResize();
        getEvents(currentDate);
        // abort request on unmount
        return function () { var _a; return (_a = requestAbortController.current) === null || _a === void 0 ? void 0 : _a.abort(); };
    }, []);
    var handleMonthChange = function (date) {
        if (requestAbortController.current) {
            // make sure that you are aborting useless requests
            // because it is possible to switch between months pretty quickly
            requestAbortController.current.abort();
        }
        setIsLoading(true);
        setHighlightedDays([]);
        getEvents(date);
    };
    var handleEventNameChange = function (e) {
        setEventName(e.target.value);
    };
    var handleEventDescriptionChange = function (e) {
        setEventDescription(e.target.value);
    };
    var handleEventStartTimeChange = function (e) {
        console.log('changed', e);
        if (e != null) {
            setEventStartTimeInvalid(!e.isValid());
            setEventStartTime(e);
        }
    };
    var handleEventEndTimeChange = function (e) {
        console.log('changed', e);
        if (e != null) {
            setEventEndTimeInvalid(!e.isValid());
            setEventEndTime(e);
        }
    };
    var handleDayChange = function (e, newEvents) {
        console.log('day changed');
        if (e != null) {
            setCurrentDate(e);
            var newFilteredList = newEvents.filter(function (event) { return event.EventStartTime.getFullYear() == e.year() && event.EventStartTime.getMonth() == e.month() && event.EventStartTime.getDate() == e.date(); });
            setFilteredEvents(__spreadArray([], newFilteredList));
        }
    };
    ;
    var handleEventLocationChange = function (e) {
        setEventLocation(e.target.value);
    };
    var handleEventCoordinatorsChange = function (e) {
        setEventCoordinators(e.target.value);
    };
    var deleteEvent = function (id) {
        setReady(false);
        var event = events.filter(function (event) { return event.EventId == id; })[0];
        EventService_1.default.UpdateEvent(event.EventId, event.EventName, event.EventDescription, event.EventLocation, event.EventStartTime, event.EventEndTime, null, null, true, event.EventCoordinators).then(function (response) {
            if (response != null && response.Event != null) {
                var newSetEvents = __spreadArray([], events);
                var index = newSetEvents.map(function (event) { return event.EventId; }).indexOf(id);
                newSetEvents.splice(index, 1);
                setEvents(__spreadArray([], newSetEvents));
                handleDayChange(currentDate, newSetEvents);
                updateHighlightedDays(newSetEvents, currentDate);
                showSuccessMessage('Event deleted successfully!');
            }
            else {
                showErrorMessage('Unknown error occured deleting event!');
            }
            setReady(true);
        });
    };
    var openEvent = function (event) {
        setEventName(event.EventName);
        setEventDescription(event.EventDescription);
        setEventLocation(event.EventLocation);
        console.log('event', event);
        setFileLocation(event.EventFileLocation);
        setFile(undefined);
        var startTime = dayjs(event.EventStartTime);
        setEventStartTime(startTime);
        var endTime = dayjs(event.EventEndTime);
        setEventEndTime(endTime);
        setEventId(event.EventId);
        setEventCoordinators(event.EventCoordinators);
        setAddingNewEvent(true); //TODO: change name
        setIsInvalid(event.EventId !== '');
    };
    var handleFileChange = function (e) {
        var file = e.target.files[0];
        setFileLocation(URL.createObjectURL(file));
        setFile(file);
    };
    return (React.createElement(Box_1.default, { component: "main", sx: { flexGrow: 1, p: 3 } },
        React.createElement(DrawerHeader, null),
        !ready &&
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })),
        ready &&
            React.createElement(React.Fragment, null,
                React.createElement("div", { style: isMobile ? calendarContainerStyleWhole : calendarContainerStyleHalf },
                    React.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs },
                        React.createElement(DateCalendar_1.DateCalendar, { className: 'calendarStyle', defaultValue: currentDate, loading: isLoading, onMonthChange: handleMonthChange, onChange: function (e) { handleDayChange(e, events); }, renderLoading: function () { return React.createElement(DayCalendarSkeleton_1.DayCalendarSkeleton, null); }, slots: {
                                day: ServerDay,
                            }, slotProps: {
                                day: {
                                    highlightedDays: highlightedDays,
                                },
                            } }))),
                React.createElement("div", { hidden: addingNewEvent, className: isMobile ? "eventsContainerWhole" : "eventsContainerHalf" },
                    React.createElement(List_1.default, { sx: { width: '100%', bgcolor: 'background.paper' } }, filteredEvents.map(function (event) { return (React.createElement("div", { key: event.EventId },
                        React.createElement(Event_2.default, { id: event.EventId, name: event.EventName, documentLocation: event.EventFileLocation, location: event.EventLocation, description: event.EventDescription, startDate: event.EventStartTime, endDate: event.EventEndTime, eventCoordinators: event.EventCoordinators, openEvent: openEvent, delete: deleteEvent }),
                        React.createElement(Divider_1.default, null))); })),
                    React.createElement("div", { className: "event-name", hidden: filteredEvents.length != 0 }, "There are no events planned for this date."),
                    role === 'Admin' &&
                        React.createElement(Fab_1.default, { color: "primary", style: { float: 'right' }, variant: "extended", onClick: function () {
                                setEventLocation('');
                                setEventDescription('');
                                setEventName('');
                                setFileLocation('');
                                setEventStartTime(currentDate);
                                setEventEndTime(currentDate);
                                setEventId('');
                                setEventCoordinators('');
                                setFile(undefined);
                                setAddingNewEvent(true);
                            } },
                            React.createElement(Add_1.default, null),
                            " Add New Event")),
                React.createElement("div", { className: "dialog", id: "dialog", hidden: !addingNewEvent },
                    React.createElement("form", { className: "form", id: "form" },
                        React.createElement("div", { className: "form-container", style: { width: (isMobile ? '100%' : '50%'), float: "right" } },
                            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Event Name", variant: "outlined", fullWidth: true, onChange: handleEventNameChange, value: eventName, error: isInvalid && eventName === "", helperText: isInvalid && eventName === "" ? 'Event name is required' : '' }),
                            React.createElement(TextField_1.default, { multiline: true, rows: 4, id: "outlined-basic", margin: "normal", label: "Description", variant: "outlined", fullWidth: true, onChange: handleEventDescriptionChange, value: eventDescription }),
                            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Location", variant: "outlined", fullWidth: true, onChange: handleEventLocationChange, value: eventLocation, error: isInvalid && eventLocation === "", helperText: isInvalid && eventLocation === "" ? 'Event location is required' : '' }),
                            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Event Coordinators", variant: "outlined", fullWidth: true, onChange: handleEventCoordinatorsChange, value: eventCoordinators }),
                            React.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs },
                                React.createElement(TimePicker_1.TimePicker, { label: "Start Time", slotProps: { textField: { fullWidth: true, margin: "normal" } }, onChange: handleEventStartTimeChange, value: eventStartTime })),
                            eventStartTimeInvalid &&
                                React.createElement(material_1.FormHelperText, { error: true }, "Event time is invalid"),
                            React.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs },
                                React.createElement(TimePicker_1.TimePicker, { label: "End Time", slotProps: { textField: { fullWidth: true, margin: "normal" } }, onChange: handleEventEndTimeChange, value: eventEndTime })),
                            eventEndTimeInvalid &&
                                React.createElement(material_1.FormHelperText, { error: true }, "Event time is invalid"),
                            React.createElement(Button_1.default, { component: "label", variant: "contained", startIcon: React.createElement(CloudUpload_1.default, null) },
                                "Upload Document",
                                React.createElement(VisuallyHiddenInput, { type: "file", onChange: handleFileChange })),
                            React.createElement("br", null),
                            fileLocation !== '' && fileLocation !== null &&
                                React.createElement("a", { href: fileLocation, download: true }, "View Document"),
                            React.createElement("br", null),
                            React.createElement(Stack_1.default, { spacing: 2, direction: "row", justifyContent: "flex-end" },
                                React.createElement(Button_1.default, { variant: "outlined", onClick: function () {
                                        setAddingNewEvent(false);
                                        setIsInvalid(false);
                                    } }, "Cancel"),
                                React.createElement(Button_1.default, { variant: "contained", onClick: function () {
                                        if (eventName.trim() === "" || !eventEndTime.isValid() || !eventStartTime.isValid() || eventLocation.trim() === "") {
                                            setIsInvalid(true);
                                            showErrorMessage('Event information is not valid!');
                                            return;
                                        }
                                        var newEvent = new Event_1.EventModel();
                                        newEvent.EventId = eventId;
                                        newEvent.EventStartTime = new Date(currentDate.year(), currentDate.month(), currentDate.date(), eventStartTime.hour(), eventStartTime.minute());
                                        newEvent.EventEndTime = new Date(currentDate.year(), currentDate.month(), currentDate.date(), eventEndTime.hour(), eventEndTime.minute());
                                        newEvent.EventLocation = eventLocation;
                                        newEvent.EventDescription = eventDescription;
                                        newEvent.EventName = eventName;
                                        newEvent.EventCoordinators = eventCoordinators;
                                        if (file != undefined) {
                                            var reader_1 = new FileReader();
                                            reader_1.readAsDataURL(file);
                                            reader_1.onload = function () {
                                                if (reader_1.result != null) {
                                                    console.log('file name', file.name);
                                                    upsertEvent(newEvent, reader_1.result.toString().split('base64,')[1], file.name);
                                                }
                                            };
                                            reader_1.onerror = function (error) {
                                                console.log('Error: ', error);
                                            };
                                        }
                                        else {
                                            upsertEvent(newEvent, null, null);
                                        }
                                        setAddingNewEvent(false);
                                        setIsInvalid(false);
                                    } }, "Confirm")),
                            React.createElement("br", null),
                            React.createElement("br", null)))))));
}
exports.default = Calendar;
//# sourceMappingURL=Calendar.js.map